import {FormCheck, FormControl} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useEffectPromise} from "../../../Hooks/EffectHooks";

export const ServiceDrivenCheckboxesFieldEditor = (Service) => {
	
	if(!Service) {
		debugger;
	}
	
	return (props) => {
	
		const {Value, OnUpdate, FieldDef, CustomData} = props;
		const {
			className = null,
			value = Value ?? [],
			onChange = OnUpdate,
			fieldDef = FieldDef,
			customData = CustomData,
			additionalOptions = [],
			context = false
		} = props;
		
		const [models, setModels] = useState(null);
		
		const loadModels = async (context) => {
			try {
				return (await Service.GetWithContext(context))?.result ?? [];
			} catch (e) {
				console.log('loadModels failed for Service:', Service, e);
			}
			return null;
		}
		
		useEffectPromise(
			async () => loadModels(context),
			(result) => {
				setModels(result);
			},
			[JSON.stringify(context)],
			true
		);
	
		const modelOptions = models?.map(model => ({
			key: Service.GetPrimaryKey(model),
			value: Service.GetPrimaryKey(model),
			title: Service.GetTitle(model),
		})) ?? [];
	
		let options = [
			...additionalOptions,
			...modelOptions,
		];
	
		const checkboxComponents = options.map(option => {
			const optionKey = option?.key ?? option?.value;
			
			return <FormCheck
				key={optionKey}
				id={optionKey}
				type="checkbox"
				label={option?.title ?? option?.value}
				checked={value.find(x => Number(x) === Number(option.key))}
				onChange={(x) => {
					const newValue = value.filter(x => Number(x) !== Number(option.key))
					if (newValue.length === value.length) {
						newValue.push(option.key);
					}
					return onChange?.(newValue);
				}}
			/>
		}) ?? null
		
		const selectAllIsChecked = options.length === value.length;
		const selectAllCheckbox = <FormCheck
			key='select-all'
			id='select-all'
			type="checkbox"
			label="Select All"
			checked={selectAllIsChecked}
			onChange={(x) => 				
				onChange(selectAllIsChecked ? [] : options.map(x => x.key))
			}
		/>
		
		return <div className="sb-checkbox-multiselect">
			{selectAllCheckbox}
			{checkboxComponents}
		</div>;
	};
};

